export default __webpack_public_path__ + "static/media/abyssofkunwhu.08fcdc2a.jpg";